import { useRouter } from 'next/router';
import { Text } from '@ui/atoms';
import { Button } from '@ui/atoms/design-system';
import AccordionItem from '@ui/molecules/Faq/AccordionItem';

import { fdFAQContent } from '@components/Products/FixedDeposits/utils/helper';

const FDFaqs = () => {
    const router = useRouter();
    return (
        <section className="md:py-8 max-w-[1082px] mx-auto w-full flex flex-col gap-6 py-6 px-4 xl:px-0 items-center">
            <Text
                content={fdFAQContent.title}
                className="text-center h5-semibold md:h2-semibold text-primary-500"
                isInnerHtml
                htmlTag="h2"
            />
            <div className="flex flex-col w-full">
                {fdFAQContent.faqs.map((faq, index) => (
                    <div key={index} className="mt-4">
                        <AccordionItem
                            key={index}
                            question={faq.question}
                            answer={faq.answer}
                        />
                    </div>
                ))}
            </div>

            <Button
                buttonText="View all"
                buttonType="outline"
                className="w-full md:w-auto"
                onClick={() => {
                    router.push(`/faq/#fixed-deposit`);
                }}
            />
        </section>
    );
};

export default FDFaqs;
